import type { ILabelProps } from '../../types'

import * as S from './index.styles'

export function Label({ children, ...rest }: ILabelProps) {
  return (
    <S.Label {...rest} numberOfLines={1} ellipsizeMode="tail">
      {children}
    </S.Label>
  )
}
